<div class="assessment-report">
  <div class="performance_options">
    <span *ngFor="let option of performanceOptions" [ngClass]="{'active': selectedOption == option}" (click)="changeOption(option)">{{option}}</span>
  </div>

  <div class="selfAssessmentParent">
    <div class="useractivityParent">
      <div class="useractivity_left_parent">
        <div class="useractivity_table">
          <div class="dropdown-wrapper">
            <div class="dropdown-wrapper-parent flex align-items-center justify-content-between">
              <div class="course_filter flex flex-col align-items-center" *ngIf="subscribedCourses?.length > 0">
                <span>Course</span>
                <p-dropdown [options]="subscribedCourses" [(ngModel)]="selectedCourse" optionLabel="courseName" optionValue="courseID" (onChange)="handleSingleCourse($event.value)" styleClass="w-full"></p-dropdown>
              </div>
              
              <div class="course_filter flex flex-col align-items-center" *ngIf="assesmentsList?.length > 0">
                <span>Assessment</span>
                <p-dropdown [options]="assesmentsList" [(ngModel)]="selectAssessment" optionLabel="name" optionValue="assessment_id" (onChange)="getAssessmentReport()" styleClass="w-full"></p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="loader" style="margin-top: 5rem;" *ngIf="loader && selectedOption == performanceOptions[0]">
    <app-page-loader></app-page-loader>
  </div>

  <!-- Percentile Rank Section -->
  <div class="row" *ngIf="!loader && selectedOption == performanceOptions[0]">
    <div class="tests_details" style="min-width: 95%;">
      <div class="comparison" style="min-width: 90%; margin-left: auto; margin-right: auto;">
        <div class="peer1">
          <div class="eup-ov-cards-heading">
            <h5>Percentile Rank</h5>
          </div>
          <hr/>
          <div class="card">
            <app-bell-chart 
              [userRank]="userRank" 
              [peerRank]="peerRank" 
              [xUserValue]="xUserValue" 
              [xPeerValue]="xPeerValue" 
              [yUserValue]="yUserValue" 
              [avgQuizScore]="avgQuizScore" 
              [avgPeerQuizScore]="avgPeerQuizScore"
              [isSelfAssessment]="true">
            </app-bell-chart>
            <div class="tooptip">
              <i
                class="fa fa-info-circle"
                [pTooltip]="'You got a score that is higher than ' + userRank +  '% of course subscribers and ' + (100 - userRank) + '% of course subscribers got a score that is higher than your score.'"
                tooltipPosition="right"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  

  <div class="container" *ngIf="selectedOption == performanceOptions[0] && !loader">
    <div class="row">
      <div class="col-md-12">
        <div class="eup-ov-cards-heading">
          <h5>Your Score</h5>
        </div>
        <div class="eup-ov-cards-wrapper col-sm-12">
          <div class="eup-ov-single-card col-sm-6 col-md-4">
            <div class="eup-green-card">
              <p-card styleClass="eup-green-card">
                <div class="eup-ov-card-value text-center">
                  <p-skeleton width="4rem" styleClass="p-mb-2 p-mx-auto" *ngIf="contentLoader"></p-skeleton>
                  <span *ngIf="!contentLoader">{{totalCorrect}}</span>
                </div>
                <div class="eup-ov-card-text">
                  <p-skeleton width="10rem" styleClass="p-mb-2" *ngIf="contentLoader"></p-skeleton>
                  <span *ngIf="!contentLoader">Total Correct</span>
                </div>
              </p-card>
            </div>
          </div>
          <div class="eup-ov-single-card col-sm-6 col-md-4">
            <div class="eup-red-card">
              <p-card styleClass="eup-red-card">
                <div class="eup-ov-card-value">
                  <p-skeleton width="4rem" styleClass="p-mb-2 p-mx-auto" *ngIf="contentLoader"></p-skeleton>
                  <span *ngIf="!contentLoader">{{totalIncorrect}}</span>
                </div>
                <div class="eup-ov-card-text">
                  <p-skeleton width="10rem" styleClass="p-mb-2" *ngIf="contentLoader"></p-skeleton>
                  <span *ngIf="!contentLoader">Total Incorrect</span>
                </div>
              </p-card>
            </div>
          </div>
          <div class="eup-ov-single-card col-sm-6 col-md-4">
            <div class="eup-blue-card">
              <p-card styleClass="eup-blue-card">
                <div class="eup-ov-card-value">
                  <p-skeleton width="4rem" styleClass="p-mb-2 p-mx-auto" *ngIf="contentLoader"></p-skeleton>
                  <span *ngIf="!contentLoader">{{totalOmitted}}</span>
                </div>
                <div class="eup-ov-card-text">
                  <p-skeleton width="10rem" styleClass="p-mb-2" *ngIf="contentLoader"></p-skeleton>
                  <span *ngIf="!contentLoader">Total Omitted</span>
                </div>
              </p-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row eup-ov-charts-wrapper" *ngIf="selectedOption == performanceOptions[0] && !loader">
    

    <div class="col-md-10 col-lg-6 eup-ov-right-chart mt-2 mb-2">
      <div class="eup-ov-chart">
        <div class="row">
          <div class="col-md-12">
            <div class="eup-ov-data-chart-pointers">
              <div class="ml-3 text-weight-bold heading_answer_changes eup-ov-cards-heading">
                <h5>Answer Changes</h5>
              </div>
              <div class="eup-ov-chart-pointer" *ngFor="let label of cardLabels;let i = index;">
                <div class="chart_headings">
                  <p class="chart_labels">{{label.label}}</p>
                </div>
                <div class="chart_number">
                  <div class="number {{pointersColorClasses[i]}}">
                    {{label.value}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Chance of Passing Widget -->
    <div class="col-md-10 col-lg-6 eup-ov-right-chart mt-2 mb-2">
      <div class="eup-ov-chart">
        <div class="row">
          <div class="col-md-12">
            <div class="eup-ov-cards-heading">
              <h5>Chance of Passing</h5>
              <span class="style-red">{{chanceOfPassing<= 25 ?'Low':chanceOfPassing>25 && chanceOfPassing<=50 ? 'Borderline':chanceOfPassing>50 && chanceOfPassing<=75 ? 'High':'Very High'}}</span>
              <i class="fa fa-info-circle" 
              [pTooltip]="'Chance of Passing: Indicates your probability of passing your exam. This is an estimate based on our proprietary algorithms & data and does not constitute a guarantee.\n\nVery High: Indicates that your probability of passing your exam is highest amongst a group of users who have used our product.\n\nHigh: Indicates that your probability of passing is somewhat higher than the rest of users but there are still areas which require improvement.\n\nBorderline: Indicates that we are unable to determine your probability of passing. We do not have sufficient data based on your performance to reach a definite conclusion.\n\nLow: Indicates that your probability of passing your exam is extremely low. You will need to identify areas that require improvement and work on them diligently in order to increase your chances of success.'"
              tooltipPosition="right"
              tooltipStyleClass="wide-tooltip"
              style="margin-left: 5px; cursor: pointer;"></i>
            </div>
            <div class="passing-chance-container">
              <div class="passing-chance-bar">
                <div class="chance-segment low" [class.active]="chanceOfPassing <= 60">
                  Low
                  <div class="arrow-indicator" *ngIf="chanceOfPassing <= 60">▼</div>
                </div>
                <div class="chance-segment" [class.active]="chanceOfPassing > 60 && chanceOfPassing <= 65">
                  Borderline
                  <div class="arrow-indicator" *ngIf="chanceOfPassing > 60 && chanceOfPassing <= 65">▼</div>
                </div>
                <div class="chance-segment" [class.active]="chanceOfPassing > 65 && chanceOfPassing <= 70">
                  High
                  <div class="arrow-indicator" *ngIf="chanceOfPassing > 65 && chanceOfPassing <= 70">▼</div>
                </div>
                <div class="chance-segment vhigh" [class.active]="chanceOfPassing > 70">
                  Very High
                  <div class="arrow-indicator" *ngIf="chanceOfPassing > 70">▼</div>
                </div>
              </div>

              <div class="score-display mt-3 text-center" *ngIf="threedigitScore !== 0">
                <div class="score-label">3 digit score</div>
                <div class="score-value">{{threedigitScore.toFixed(0)}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="formula-chart " *ngIf="selectedOption == performanceOptions[0] && !loader && userGraph !== 'null'">
    <div class="eup-ov-data-chart-pointers">
      <div class="ml-3 text-weight-bold heading_answer_changes eup-ov-cards-heading">
        <h5>Formula to Calculate Score</h5>
      </div>
      <div class="eup-ov-chart-pointer" >
        <div class="chart_headings">
          <img *ngIf="userGraph" class="graph-image" [src]="userGraph" alt="">
      </div>
    </div>
  </div>

  </div>

 

  

  <!-- Analysis Chart Section -->
  <!-- <div class="analysis-chart" *ngIf="selectedOption == performanceOptions[1] && !loader">
    <div class="tests_details">
      <div class="comparison" style="min-width: 90%; margin-left: auto; margin-right: auto;">
        <div class="peer1">
          <div class="eup-ov-cards-heading">
            <h5>Performance Analysis</h5>
          </div>
          <hr/>
          <div class="card">
            <p-chart type="bar" [data]="barData" [options]="barOptions"></p-chart>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <app-performance-table *ngIf="selectedOption == performanceOptions[1]" [assessmentId]="selectAssessment" [reporting]="true" [subscribedCourses]="subscribedCourses"></app-performance-table>
</div>
